__turbopack_context__.v({
  "carbonEquivalentsList": "pWX6tq_carbonEquivalentsList",
});
